(() => {
  const CARD_SELECTOR = '.card-product';
  const QUICKADD_SELECTOR = '[data-card-size-quickadd]';
  const QUICKADD_LIST_SELECTOR = '[data-card-size-quickadd-list]';
  const VARIANTS_JSON_SELECTOR = '.x-variants-data script[type="application/json"]';
  const CARD_OPTION_FIELDSET_SELECTOR = 'fieldset[data-card-option-index]';

  function parseVariants(card) {
    const script = card.querySelector(VARIANTS_JSON_SELECTOR);
    if (!script) return [];

    try {
      return JSON.parse(script.textContent || '[]');
    } catch (error) {
      console.warn('카드 variants JSON 파싱 실패', error);
      return [];
    }
  }

  function getQuickaddContainer(card) {
    return card.querySelector(QUICKADD_SELECTOR);
  }

  function getQuickaddList(card) {
    return card.querySelector(QUICKADD_LIST_SELECTOR);
  }

  function getOptionIndex(card, key) {
    const quickadd = getQuickaddContainer(card);
    if (!quickadd) return null;

    const raw = quickadd.dataset[key];
    if (raw === undefined || raw === '') return null;

    const parsed = Number(raw);
    return Number.isNaN(parsed) ? null : parsed;
  }

  function getSelectedOptions(card) {
    const selected = {};

    card.querySelectorAll(CARD_OPTION_FIELDSET_SELECTOR).forEach((fieldset) => {
      const optionIndex = Number(fieldset.dataset.cardOptionIndex);
      if (Number.isNaN(optionIndex)) return;

      const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
      if (!checkedInput) return;

      selected[optionIndex] = checkedInput.value;
    });

    return selected;
  }

  function getSelectedColor(card) {
    const colorFieldset = card.querySelector('fieldset[data-card-color-option="true"]');
    if (!colorFieldset) return null;

    const checkedInput = colorFieldset.querySelector('input[type="radio"]:checked');
    if (!checkedInput) return null;

    return checkedInput.value;
  }

  function buildSizeItems(card) {
    const variants = parseVariants(card);
    const colorOptionIndex = getOptionIndex(card, 'colorOptionIndex');
    const sizeOptionIndex = getOptionIndex(card, 'sizeOptionIndex');
    const selectedColor = getSelectedColor(card);
    const selectedOptions = getSelectedOptions(card);

    if (!variants.length || colorOptionIndex === null || sizeOptionIndex === null || !selectedColor) {
      return [];
    }

    const sizeMap = new Map();

    variants.forEach((variant) => {
      const options = Array.isArray(variant.options) ? variant.options : [];

      const variantColor = options[colorOptionIndex];
      const variantSize = options[sizeOptionIndex];

      if (!variantColor || !variantSize) return;
      if (variantColor !== selectedColor) return;

      let matchesOtherSelectedOptions = true;

      Object.keys(selectedOptions).forEach((key) => {
        const optionIndex = Number(key);

        if (optionIndex === colorOptionIndex || optionIndex === sizeOptionIndex) return;

        const selectedValue = selectedOptions[optionIndex];
        const variantValue = options[optionIndex];

        if (selectedValue && variantValue !== selectedValue) {
          matchesOtherSelectedOptions = false;
        }
      });

      if (!matchesOtherSelectedOptions) return;

      if (!sizeMap.has(variantSize)) {
        sizeMap.set(variantSize, {
          label: variantSize,
          available: !!variant.available,
          variantId: variant.id
        });
        return;
      }

      const existing = sizeMap.get(variantSize);

      if (!existing.available && variant.available) {
        sizeMap.set(variantSize, {
          label: variantSize,
          available: true,
          variantId: variant.id
        });
      }
    });

    return Array.from(sizeMap.values());
  }

  function renderEmptyState(listEl) {
    listEl.innerHTML = '<button type="button" class="card-size-chip is-empty" disabled>-</button>';
  }

  function renderCardsInScope(scope) {
    const root = scope instanceof Element ? scope : document;

    root.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      renderSizeChips(card);
    });
  }

  function renderSizeChips(card) {
    const listEl = getQuickaddList(card);
    if (!listEl) return;

    const sizeItems = buildSizeItems(card);

    if (!sizeItems.length) {
      renderEmptyState(listEl);
      return;
    }

    const html = sizeItems.map((item) => {
      const disabledClass = item.available ? '' : ' is-disabled';
      const disabledAttr = item.available ? '' : ' disabled';
      const variantAttr = item.variantId ? ` data-variant-id="${item.variantId}"` : '';

      return `
        <button
          type="button"
          class="card-size-chip${disabledClass}"
          data-size-value="${item.label}"
          ${variantAttr}
          ${disabledAttr}
        >
          ${item.label}
        </button>
      `;
    }).join('');

    listEl.innerHTML = html;
  }

  function renderAllCards() {
    renderCardsInScope(document);
  }

  function rerenderCard(card) {
    if (!card) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        renderSizeChips(card);
      });
    });
  }
  
  function wait(ms) {
    return new Promise((resolve) => {
      window.setTimeout(resolve, ms);
    });
  }

  function waitForCartChanged(timeout = 3000) {
    return new Promise((resolve) => {
      let done = false;

      const finish = () => {
        if (done) return;
        done = true;
        document.removeEventListener('eurus:cart:items-changed', onChanged);
        resolve();
      };

      const onChanged = () => {
        finish();
      };

      document.addEventListener('eurus:cart:items-changed', onChanged, { once: true });
      window.setTimeout(finish, timeout);
    });
  }

  function setChipLoadingState(chip, isLoading) {
    if (!chip) return;

    if (isLoading) {
      chip.classList.add('is-loading');
      chip.setAttribute('aria-busy', 'true');
      return;
    }

    chip.classList.remove('is-loading');
    chip.removeAttribute('aria-busy');
  }

  function getHiddenAtcRoot(card) {
    return card.querySelector('[data-card-size-atc-root]');
  }

  function getHiddenAtcForm(card) {
    const root = getHiddenAtcRoot(card);
    if (!root) return null;

    return root.querySelector('form[data-type="add-to-cart-form"]');
  }

  function getHiddenAtcIdInput(card) {
    const form = getHiddenAtcForm(card);
    if (!form) return null;

    return form.querySelector('[data-card-size-atc-id]');
  }

  function getHiddenAtcSubmit(card) {
    const form = getHiddenAtcForm(card);
    if (!form) return null;

    return form.querySelector('[data-card-size-atc-submit]');
  }

  function updateHiddenAtcVariant(card, variantId) {
    const idInput = getHiddenAtcIdInput(card);
    if (!idInput) return false;

    idInput.value = variantId;
    idInput.setAttribute('value', variantId);
    idInput.dispatchEvent(new Event('change', { bubbles: true }));

    return true;
  }

  async function handleChipAddToCart(chip) {
    if (!chip || chip.disabled || chip.classList.contains('is-loading')) return;

    const card = chip.closest(CARD_SELECTOR);
    const variantId = chip.dataset.variantId;

    if (!card || !variantId) return;

    setChipLoadingState(chip, true);

    try {
      const updated = updateHiddenAtcVariant(card, variantId);
      if (!updated) {
        throw new Error('히든 ATC variant input을 찾지 못했습니다.');
      }

      const submitButton = getHiddenAtcSubmit(card);
      if (!submitButton) {
        throw new Error('히든 ATC submit 버튼을 찾지 못했습니다.');
      }

      const cartChangedPromise = waitForCartChanged();

      submitButton.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      }));

      await cartChangedPromise;
      await wait(120);
    } catch (error) {
      console.warn('카드 사이즈 퀵애드 실패', error);
    } finally {
      window.setTimeout(() => {
        setChipLoadingState(chip, false);
      }, 300);
    }
  }

  document.addEventListener('change', (event) => {
    const changedInput = event.target.closest('.options-container input[type="radio"]');
    if (!changedInput) return;

    const card = changedInput.closest(CARD_SELECTOR);
    if (!card) return;

    rerenderCard(card);
  });

  document.addEventListener('click', (event) => {
    const chip = event.target.closest('.card-size-chip');
    if (!chip) return;
    if (chip.disabled) return;

    const list = chip.closest(QUICKADD_LIST_SELECTOR);
    if (!list) return;

    event.preventDefault();
    handleChipAddToCart(chip);
  });

  // document.addEventListener('DOMContentLoaded', () => {
  //   renderAllCards();
  // });
  
  // document.addEventListener('shopify:section:load', () => {
  //   renderAllCards();
  // });
  
  // requestAnimationFrame(() => {
  //   renderAllCards();
  // });

  function initQuickAdd() {
    renderAllCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickAdd, { once: true });
  } else {
    initQuickAdd();
  }

  document.addEventListener('shopify:section:load', (event) => {
    renderCardsInScope(event.target);
  });

  document.addEventListener('reclop:product-grid:updated', (event) => {
    const container = event.detail && event.detail.container ? event.detail.container : document;

    requestAnimationFrame(() => {
      renderCardsInScope(container);
    });
  });

  document.addEventListener('reclop:product-recommendations:updated', (event) => {
    const container = event.detail && event.detail.container ? event.detail.container : document;

    requestAnimationFrame(() => {
      renderCardsInScope(container);
    });
  });

  document.addEventListener('reclop:recently-viewed:updated', (event) => {
    const container = event.detail && event.detail.container ? event.detail.container : document;

    requestAnimationFrame(() => {
      renderCardsInScope(container);
    });
  });
})();

/* 필터 후 Alpine 재초기화 */
// function reinitAlpine(root = document) {
//   if (!window.Alpine) return;

//   root.querySelectorAll('[x-data]').forEach((el) => {
//     try {
//       Alpine.initTree(el);
//     } catch (e) {
//       console.warn('Alpine init error:', e);
//     }
//   });
// }


// (() => {
//   const CARD_SELECTOR = '.card-product';
//   const QUICKADD_SELECTOR = '[data-card-size-quickadd]';
//   const QUICKADD_LIST_SELECTOR = '[data-card-size-quickadd-list]';
//   const VARIANTS_JSON_SELECTOR = '.x-variants-data script[type="application/json"]';
//   const CARD_OPTION_FIELDSET_SELECTOR = 'fieldset[data-card-option-index]';
//   const RENDER_RETRY_LIMIT = 4;
//   const RENDER_RETRY_DELAY = 80;

//   function parseVariants(card) {
//     const script = card.querySelector(VARIANTS_JSON_SELECTOR);
//     if (!script) return [];

//     try {
//       return JSON.parse(script.textContent || '[]');
//     } catch (error) {
//       console.warn('카드 variants JSON 파싱 실패', error);
//       return [];
//     }
//   }

//   function getQuickaddContainer(card) {
//     return card.querySelector(QUICKADD_SELECTOR);
//   }

//   function getQuickaddList(card) {
//     return card.querySelector(QUICKADD_LIST_SELECTOR);
//   }

//   function getOptionIndex(card, key) {
//     const quickadd = getQuickaddContainer(card);
//     if (!quickadd) return null;

//     const raw = quickadd.dataset[key];
//     if (raw === undefined || raw === '') return null;

//     const parsed = Number(raw);
//     return Number.isNaN(parsed) ? null : parsed;
//   }

//   function getSelectedOptions(card) {
//     const selected = {};

//     card.querySelectorAll(CARD_OPTION_FIELDSET_SELECTOR).forEach((fieldset) => {
//       const optionIndex = Number(fieldset.dataset.cardOptionIndex);
//       if (Number.isNaN(optionIndex)) return;

//       const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
//       if (!checkedInput) return;

//       selected[optionIndex] = checkedInput.value;
//     });

//     return selected;
//   }

//   function getSelectedColor(card) {
//     const colorFieldset = card.querySelector('fieldset[data-card-color-option="true"]');
//     if (!colorFieldset) return null;

//     const checkedInput = colorFieldset.querySelector('input[type="radio"]:checked');
//     if (!checkedInput) return null;

//     return checkedInput.value;
//   }

//   function buildSizeItems(card) {
//     const variants = parseVariants(card);
//     const colorOptionIndex = getOptionIndex(card, 'colorOptionIndex');
//     const sizeOptionIndex = getOptionIndex(card, 'sizeOptionIndex');
//     const selectedColor = getSelectedColor(card);
//     const selectedOptions = getSelectedOptions(card);

//     if (!variants.length || colorOptionIndex === null || sizeOptionIndex === null || !selectedColor) {
//       return [];
//     }

//     const sizeMap = new Map();

//     variants.forEach((variant) => {
//       const options = Array.isArray(variant.options) ? variant.options : [];

//       const variantColor = options[colorOptionIndex];
//       const variantSize = options[sizeOptionIndex];

//       if (!variantColor || !variantSize) return;
//       if (variantColor !== selectedColor) return;

//       let matchesOtherSelectedOptions = true;

//       Object.keys(selectedOptions).forEach((key) => {
//         const optionIndex = Number(key);

//         if (optionIndex === colorOptionIndex || optionIndex === sizeOptionIndex) return;

//         const selectedValue = selectedOptions[optionIndex];
//         const variantValue = options[optionIndex];

//         if (selectedValue && variantValue !== selectedValue) {
//           matchesOtherSelectedOptions = false;
//         }
//       });

//       if (!matchesOtherSelectedOptions) return;

//       if (!sizeMap.has(variantSize)) {
//         sizeMap.set(variantSize, {
//           label: variantSize,
//           available: !!variant.available,
//           variantId: variant.id
//         });
//         return;
//       }

//       const existing = sizeMap.get(variantSize);

//       if (!existing.available && variant.available) {
//         sizeMap.set(variantSize, {
//           label: variantSize,
//           available: true,
//           variantId: variant.id
//         });
//       }
//     });

//     return Array.from(sizeMap.values());
//   }

//   function renderEmptyState(listEl) {
//     listEl.innerHTML = '<button type="button" class="card-size-chip is-empty" disabled>-</button>';
//   }


//   function renderSizeChips(card, attempt = 0) {
//     const listEl = getQuickaddList(card);
//     if (!listEl) return;

//     const sizeItems = buildSizeItems(card);

//     if (!sizeItems.length) {
//       const shouldRetry = !!getQuickaddContainer(card) && !getSelectedColor(card) && attempt < RENDER_RETRY_LIMIT;

//       if (shouldRetry) {
//         window.setTimeout(() => {
//           renderSizeChips(card, attempt + 1);
//         }, RENDER_RETRY_DELAY * (attempt + 1));
//         return;
//       }

//       renderEmptyState(listEl);
//       return;
//     }

//     const html = sizeItems.map((item) => {
//       const disabledClass = item.available ? '' : ' is-disabled';
//       const disabledAttr = item.available ? '' : ' disabled';
//       const variantAttr = item.variantId ? ` data-variant-id="${item.variantId}"` : '';

//       return `
//         <button
//           type="button"
//           class="card-size-chip${disabledClass}"
//           data-size-value="${item.label}"
//           ${variantAttr}
//           ${disabledAttr}
//         >
//           ${item.label}
//         </button>
//       `;
//     }).join('');

//     listEl.innerHTML = html;
//   }

//   function renderAllCards() {
//     document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
//       renderSizeChips(card);
//     });
//   }

//   let renderAllCardsRaf = null;

//   function scheduleRenderAllCards() {
//     if (renderAllCardsRaf) return;

//     renderAllCardsRaf = requestAnimationFrame(() => {
//       renderAllCardsRaf = null;
//       renderAllCards();
//     });
//   }

//   function scheduleRenderPasses(delays = [0]) {
//     delays.forEach((delay) => {
//       window.setTimeout(() => {
//         scheduleRenderAllCards();
//       }, delay);
//     });
//   }

//   function rerenderCard(card) {
//     if (!card) return;

//     requestAnimationFrame(() => {
//       requestAnimationFrame(() => {
//         renderSizeChips(card);
//       });
//     });
//   }
  
//   function wait(ms) {
//     return new Promise((resolve) => {
//       window.setTimeout(resolve, ms);
//     });
//   }

//   function waitForCartChanged(timeout = 3000) {
//     return new Promise((resolve) => {
//       let done = false;

//       const finish = () => {
//         if (done) return;
//         done = true;
//         document.removeEventListener('eurus:cart:items-changed', onChanged);
//         resolve();
//       };

//       const onChanged = () => {
//         finish();
//       };

//       document.addEventListener('eurus:cart:items-changed', onChanged, { once: true });
//       window.setTimeout(finish, timeout);
//     });
//   }

//   function setChipLoadingState(chip, isLoading) {
//     if (!chip) return;

//     if (isLoading) {
//       chip.classList.add('is-loading');
//       chip.setAttribute('aria-busy', 'true');
//       return;
//     }

//     chip.classList.remove('is-loading');
//     chip.removeAttribute('aria-busy');
//   }

//   function getHiddenAtcRoot(card) {
//     return card.querySelector('[data-card-size-atc-root]');
//   }

//   function getHiddenAtcForm(card) {
//     const root = getHiddenAtcRoot(card);
//     if (!root) return null;

//     return root.querySelector('form[data-type="add-to-cart-form"]');
//   }

//   function getHiddenAtcIdInput(card) {
//     const form = getHiddenAtcForm(card);
//     if (!form) return null;

//     return form.querySelector('[data-card-size-atc-id]');
//   }

//   function getHiddenAtcSubmit(card) {
//     const form = getHiddenAtcForm(card);
//     if (!form) return null;

//     return form.querySelector('[data-card-size-atc-submit]');
//   }

//   function updateHiddenAtcVariant(card, variantId) {
//     const idInput = getHiddenAtcIdInput(card);
//     if (!idInput) return false;

//     idInput.value = variantId;
//     idInput.setAttribute('value', variantId);
//     idInput.dispatchEvent(new Event('change', { bubbles: true }));

//     return true;
//   }

//   async function handleChipAddToCart(chip) {
//     if (!chip || chip.disabled || chip.classList.contains('is-loading')) return;

//     const card = chip.closest(CARD_SELECTOR);
//     const variantId = chip.dataset.variantId;

//     if (!card || !variantId) return;

//     setChipLoadingState(chip, true);

//     try {
//       const updated = updateHiddenAtcVariant(card, variantId);
//       if (!updated) {
//         throw new Error('히든 ATC variant input을 찾지 못했습니다.');
//       }

//       const submitButton = getHiddenAtcSubmit(card);
//       if (!submitButton) {
//         throw new Error('히든 ATC submit 버튼을 찾지 못했습니다.');
//       }

//       const cartChangedPromise = waitForCartChanged();

//       submitButton.dispatchEvent(new MouseEvent('click', {
//         bubbles: true,
//         cancelable: true,
//         view: window
//       }));

//       await cartChangedPromise;
//       await wait(120);
//     } catch (error) {
//       console.warn('카드 사이즈 퀵애드 실패', error);
//     } finally {
//       window.setTimeout(() => {
//         setChipLoadingState(chip, false);
//       }, 300);
//     }
//   }

//   document.addEventListener('change', (event) => {
//     const changedInput = event.target.closest('.options-container input[type="radio"]');
//     if (!changedInput) return;

//     const card = changedInput.closest(CARD_SELECTOR);
//     if (!card) return;

//     rerenderCard(card);
//   });

//   document.addEventListener('click', (event) => {
//     const chip = event.target.closest('.card-size-chip');
//     if (!chip) return;
//     if (chip.disabled) return;

//     const list = chip.closest(QUICKADD_LIST_SELECTOR);
//     if (!list) return;

//     event.preventDefault();
//     handleChipAddToCart(chip);
//   });

//   document.addEventListener('DOMContentLoaded', () => {
//     scheduleRenderPasses([0, 120, 260]);
//   });
  
//   document.addEventListener('shopify:section:load', () => {
//     scheduleRenderPasses([0, 120, 260]);
//   });
  
//   document.addEventListener('facet:updated', () => {
//     scheduleRenderPasses([0, 120, 260]);
//   });
  
//   document.addEventListener('collection:updated', () => {
//     scheduleRenderPasses([0, 120, 260]);
//   });
  
//   requestAnimationFrame(() => {
//     scheduleRenderPasses([0, 120, 260]);
//   });
// })();


// (() => {
//   const CARD_SELECTOR = '.card-product';
//   const QUICKADD_SELECTOR = '[data-card-size-quickadd]';
//   const QUICKADD_LIST_SELECTOR = '[data-card-size-quickadd-list]';
//   const VARIANTS_JSON_SELECTOR = '.x-variants-data script[type="application/json"]';
//   const CARD_OPTION_FIELDSET_SELECTOR = 'fieldset[data-card-option-index]';

//   function parseVariants(card) {
//     const script = card.querySelector(VARIANTS_JSON_SELECTOR);
//     if (!script) return [];

//     try {
//       return JSON.parse(script.textContent || '[]');
//     } catch (error) {
//       console.warn('카드 variants JSON 파싱 실패', error);
//       return [];
//     }
//   }

//   function getQuickaddContainer(card) {
//     return card.querySelector(QUICKADD_SELECTOR);
//   }

//   function getQuickaddList(card) {
//     return card.querySelector(QUICKADD_LIST_SELECTOR);
//   }

//   function getOptionIndex(card, key) {
//     const quickadd = getQuickaddContainer(card);
//     if (!quickadd) return null;

//     const raw = quickadd.dataset[key];
//     if (raw === undefined || raw === '') return null;

//     const parsed = Number(raw);
//     return Number.isNaN(parsed) ? null : parsed;
//   }

//   function getSelectedOptions(card) {
//     const selected = {};

//     card.querySelectorAll(CARD_OPTION_FIELDSET_SELECTOR).forEach((fieldset) => {
//       const optionIndex = Number(fieldset.dataset.cardOptionIndex);
//       if (Number.isNaN(optionIndex)) return;

//       const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
//       if (!checkedInput) return;

//       selected[optionIndex] = checkedInput.value;
//     });

//     return selected;
//   }

//   function getSelectedColor(card) {
//     const colorFieldset = card.querySelector('fieldset[data-card-color-option="true"]');
//     if (!colorFieldset) return null;

//     const checkedInput = colorFieldset.querySelector('input[type="radio"]:checked');
//     if (!checkedInput) return null;

//     return checkedInput.value;
//   }

//   function buildSizeItems(card) {
//     const variants = parseVariants(card);
//     const colorOptionIndex = getOptionIndex(card, 'colorOptionIndex');
//     const sizeOptionIndex = getOptionIndex(card, 'sizeOptionIndex');
//     const selectedColor = getSelectedColor(card);
//     const selectedOptions = getSelectedOptions(card);

//     if (!variants.length || colorOptionIndex === null || sizeOptionIndex === null || !selectedColor) {
//       return [];
//     }

//     const sizeMap = new Map();

//     variants.forEach((variant) => {
//       const options = Array.isArray(variant.options) ? variant.options : [];

//       const variantColor = options[colorOptionIndex];
//       const variantSize = options[sizeOptionIndex];

//       if (!variantColor || !variantSize) return;
//       if (variantColor !== selectedColor) return;

//       let matchesOtherSelectedOptions = true;

//       Object.keys(selectedOptions).forEach((key) => {
//         const optionIndex = Number(key);

//         if (optionIndex === colorOptionIndex || optionIndex === sizeOptionIndex) return;

//         const selectedValue = selectedOptions[optionIndex];
//         const variantValue = options[optionIndex];

//         if (selectedValue && variantValue !== selectedValue) {
//           matchesOtherSelectedOptions = false;
//         }
//       });

//       if (!matchesOtherSelectedOptions) return;

//       if (!sizeMap.has(variantSize)) {
//         sizeMap.set(variantSize, {
//           label: variantSize,
//           available: !!variant.available,
//           variantId: variant.id
//         });
//         return;
//       }

//       const existing = sizeMap.get(variantSize);

//       if (!existing.available && variant.available) {
//         sizeMap.set(variantSize, {
//           label: variantSize,
//           available: true,
//           variantId: variant.id
//         });
//       }
//     });

//     return Array.from(sizeMap.values());
//   }

//   function renderEmptyState(listEl) {
//     listEl.innerHTML = '<button type="button" class="card-size-chip is-empty" disabled>-</button>';
//   }

//   function renderSizeChips(card) {
//     const listEl = getQuickaddList(card);
//     if (!listEl) return;

//     const sizeItems = buildSizeItems(card);

//     if (!sizeItems.length) {
//       renderEmptyState(listEl);
//       return;
//     }

//     const html = sizeItems.map((item) => {
//       const disabledClass = item.available ? '' : ' is-disabled';
//       const disabledAttr = item.available ? '' : ' disabled';
//       const variantAttr = item.variantId ? ` data-variant-id="${item.variantId}"` : '';

//       return `
//         <button
//           type="button"
//           class="card-size-chip${disabledClass}"
//           data-size-value="${item.label}"
//           ${variantAttr}
//           ${disabledAttr}
//         >
//           ${item.label}
//         </button>
//       `;
//     }).join('');

//     listEl.innerHTML = html;
//   }

//   function renderAllCards() {
//     document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
//       renderSizeChips(card);
//     });
//   }

//   function rerenderCard(card) {
//     if (!card) return;

//     requestAnimationFrame(() => {
//       requestAnimationFrame(() => {
//         renderSizeChips(card);
//       });
//     });
//   }

//   document.addEventListener('change', (event) => {
//     const changedInput = event.target.closest('.options-container input[type="radio"]');
//     if (!changedInput) return;

//     const card = changedInput.closest(CARD_SELECTOR);
//     if (!card) return;

//     rerenderCard(card);
//   });

//   document.addEventListener('DOMContentLoaded', () => {
//     renderAllCards();
//   });

//   document.addEventListener('shopify:section:load', () => {
//     renderAllCards();
//   });

//   requestAnimationFrame(() => {
//     renderAllCards();
//   });
// })();